/**
 * FmsModAccount
 */
import { CmdType } from "../../fms.core/ApHd";
import { SQLField, SQLInfo, SQLType } from "../../framework.core/data/SQLInfo";
import { getTbNameByJobName } from "../../framework.core/JobNames";
import { isNullOrEmpty } from "../../util";

export function SaveNewJournalByMaster(mblJobName:string, mblJobId:number, userID: string):SQLInfo|null {
  if(!mblJobName || mblJobId <= 0) return null;

  // ifms.net에서는 TBName을 사용했으나, cloud에서는 jobName을 넘겨서 backend에서 tbName으로 변환하도록 한다. 
  // (JobHelper.GetTBNameByJobName을 frontend에서 사용하지 않기 위하여)
  return new SQLInfo({
    tableName: SQLInfo.SaveNewJournalByMaster,
    type: SQLType.Execute,
    fields: [
      new SQLField({ fieldName: "", propertyName: "jobName", value: mblJobName }),
      new SQLField({ fieldName: "", propertyName: "TBId", value: mblJobId }),
      new SQLField({ fieldName: "", propertyName: "LoginId", value:  userID }),
    ]
  });
}

export function SaveNewJournalByTask(jobName: string, jobId: number, userId: string = '', seqNo: number = 0): SQLInfo|null {
  if(!jobName) return null;

  const tbName = getTbNameByJobName(jobName);

  return new SQLInfo({
    tableName: SQLInfo.SaveNewJournalByTask,
    type: SQLType.Execute,
    fields: [
      new SQLField({ fieldName: "", propertyName: "TBName", value: isNullOrEmpty(tbName) ? jobName : tbName }),
      new SQLField({ fieldName: "", propertyName: "TBId", value: jobId }),
      new SQLField({ fieldName: "", propertyName: "LoginId", value: userId }),
      new SQLField({ fieldName: "", propertyName: "SeqNo", value: seqNo }),
    ]
  });
}

export function fsGetShortNameByChgType(vChgType: number): string {
  let tRet = '';
  switch(vChgType) {
    case 1: tRet = "Sales/DS"; break;
    case 2: tRet = "Collect4Agent"; break;
    case 3:
    case 4: tRet = "Sales/IDS"; break;
    case 5: tRet = "Debit Memo"; break;
    case 6: tRet = "Sales/DS"; break;
    case 7: tRet = "PS Sales Only"; break;
    case 9: tRet = "Other Sales"; break;
    case 27: tRet = "PS Sales Only"; break;

    case 11: tRet = "Cost/DS"; break;
    case 12: tRet = "Loan2Agent"; break;
    case 13:
    case 14: tRet = "Cost/IDS"; break;
    case 15: tRet = "Credit Memo"; break;
    case 16: tRet = "Cost/DS"; break;
    case 17: tRet = "PS Cost Only"; break;
    case 19: tRet = "Other Cost"; break;
    case 37: tRet = "PS Cost Only"; break;

    case 8: tRet = "Duty Agent"; break;
    case 10: tRet = "Duty Customer"; break;
    case 18: tRet = "Duty Agent"; break;
    case 20: tRet = "Duty Customer"; break;
    case 40: tRet = "Duty Customer"; break;

    default: tRet = "Unknown"; break;
  }
  return tRet;
}

export function updateStatusInvoData(jobName:string, oldId:number, newId:number, cmdType:number) {
  const sqlInfos:Array<SQLInfo> = [];
  const tbName = getTbNameByJobName(jobName);
  switch(cmdType) {
    case CmdType.Credit:
      // set f_isCredit for existing billing
      sqlInfos.push(new SQLInfo({
        tableName: tbName,
        type: SQLType.Update,
        key: new SQLField({ fieldName: 'f_id', propertyName: 'OriginInvId', value: oldId}),
        fields: [
          new SQLField({ fieldName: 'f_iscredit', propertyName: "@@tsql", value:"'1'"}),
        ]
      }));

      // settings for credit billing
      sqlInfos.push(new SQLInfo({
        tableName: tbName,
        type: SQLType.Update,
        key: new SQLField({ fieldName: 'f_id', propertyName: 'id', value: newId }),
        fields: [
          new SQLField({ fieldName: "f_iscredit", propertyName: "@@tsql", value: "'2'"}),
          new SQLField({ fieldName: "f_OriginInvId", propertyName: "OriginInvId", value: oldId})
        ]
      }));
      break;
    case CmdType.Void:
      // Mark orginal billing
      sqlInfos.push(new SQLInfo({
        tableName: tbName,
        type: SQLType.Update,
        key: new SQLField({ fieldName: 'f_id', propertyName: "OriginInvId", value: oldId}),
        fields: [
          new SQLField({ fieldName: "f_void", propertyName: "@@tsql", value: "'1'"})
        ]
      }));

      // Mark void billing
      sqlInfos.push(new SQLInfo({
        tableName: tbName,
        type: SQLType.Update,
        key: new SQLField({ fieldName: "f_id", propertyName: "id", value: newId}),
        fields: [
          new SQLField({ fieldName: "f_void", propertyName: "@@tsql", value: "'2'"}),
          new SQLField({ fieldName: "f_OriginInvId", propertyName: "OriginInvId", value: oldId})
        ]
      }));
      break;

    case CmdType.CancelCredit:
      // mark credit billing
      sqlInfos.push(new SQLInfo({
        tableName: tbName,
        type: SQLType.Update,
        key: new SQLField({ fieldName: "f_id", propertyName: "OriginInvId", value: oldId}),
        fields: [
          new SQLField({ fieldName: "f_Void", propertyName: "@@tsql", value: "'1'"}),
          new SQLField({ fieldName: "f_iscredit", propertyName: "@@tsql", value: "0"})
        ]
      }));

      // mark credit void billing
      sqlInfos.push(new SQLInfo({
        tableName: tbName,
        type: SQLType.Update,
        key: new SQLField({ fieldName: "f_id", propertyName: "id", value: newId }),
        fields: [
          new SQLField({ fieldName: "f_Void", propertyName: "@@tsql", value: "'2'"}),
          new SQLField({ fieldName: "f_iscredit", propertyName: "@@tsql", value: "'0'"}),
          new SQLField({ fieldName: "f_originInvId", propertyName: "OriginInvId", value: oldId})
        ]
      }));

      // clear isCredit
      sqlInfos.push(new SQLInfo({
        tableName: tbName,
        type: SQLType.Update,
        fields: [
          new SQLField({ fieldName: "f_iscredit", propertyName: "@@tsql", value: "'0'"}),
          // <chuck date="2021-08-05" desc="IsCredit만 초기화 시키는 것이 아니라 CheckNo, PaidDate정보도 Clear해야 한다. ">
          new SQLField({ fieldName: "F_PaidAmt", propertyName: "@@tsql", value: "0"}),
          new SQLField({ fieldName: "F_CheckNo", propertyName: "@@tsql", value: "''"}),
          new SQLField({ fieldName: "F_PaidDate", propertyName: "LastPaidDate", value: null}),
        ],
        where: `F_ID = (Select F_OriginInvId from ${tbName} where F_ID = ${oldId}) and ` +
        `(Select Count(*) from ${tbName} where F_OriginInvId = (Select F_OriginInvId from ${tbName} where F_ID = ${oldId}) AND F_IsCredit = 2) = 0`
      }));
      break;

    case CmdType.CancelVoid:
      // clear void from voided billing 
      sqlInfos.push(new SQLInfo({
        tableName: tbName,
        type: SQLType.Update,
        fields: [
          new SQLField({ fieldName: "f_void", propertyName: "@@tsql", value: "'0'"})
        ],
        where: `F_ID = (Select F_OriginInvId from ${tbName} where F_ID = ${oldId})`
      }));
      break;
  }
  return sqlInfos;
}

export function matchAdvanceInPayment(tbName:string, tbId:number, newDate:string|null, glNo:string, userID:string): SQLInfo|null {
  if(!tbName || tbId <= 0) return null;
  return new SQLInfo({
    tableName: SQLInfo.MatchAdvanceInPayment,
    type: SQLType.Execute,
    fields: [
      new SQLField({ fieldName: "", propertyName: "TBName", value: tbName}),
      new SQLField({ fieldName: "", propertyName: "TBId", value: tbId}),
      new SQLField({ fieldName: "", propertyName: "NewDate", value: newDate}),
      new SQLField({ fieldName: "", propertyName: "GlNo", value: glNo}),
      new SQLField({ fieldName: "", propertyName: "LoginID", value: userID})
    ]
  });
}

export function setStatusAll(mTbName:string, mTbId:number, isSet:boolean): SQLInfo[] | null {
  if(!mTbName || mTbId <= 0) return null;

  let hTbName = "";
  let hFieldName = "";
  const statusValue = isSet ? 1 : 0;

  switch(mTbName){
    case "T_OIMMAIN":
      hTbName = "T_OIHMAIN";
      hFieldName = "F_OIMBLID";
      break;
    case "T_OOMMAIN":
      hTbName = "T_OOHMAIN";
      hFieldName = "F_OOMBLID";
      break;
    case "T_AIMMAIN":
      hTbName = "T_AIHMAIN";
      hFieldName = "F_AIMBLID";
      break;
    case "T_AOMMAIN":
      hTbName = "T_AOHMAIN";
      hFieldName = "F_AOMBLID";
      break;
    case "T_BTLOAD":
      hTbName = "T_BTORDER";
      hFieldName = "F_LoadID";
      break;
  }

  const sqlInfos: SQLInfo[] = [];
  sqlInfos.push(new SQLInfo({
    tableName: mTbName,
    type: SQLType.Update,
    fields: [
      new SQLField({ fieldName: "f_completebill", propertyName: "completebill", value: statusValue}),
      new SQLField({ fieldName: "f_completeinvo", propertyName: "completeinvo", value: statusValue}),
      new SQLField({ fieldName: "f_completecrdb", propertyName: "completecrdb", value: statusValue}),
    ],
    key: new SQLField({ fieldName: 'f_id', propertyName: 'Id', value: mTbId}),
  }));

  if(hTbName) {
    sqlInfos.push(new SQLInfo({
      tableName: hTbName,
      type: SQLType.Update,
      fields: [
        new SQLField({ fieldName: "f_completebill", propertyName: "completebill", value: statusValue}),
        new SQLField({ fieldName: "f_completeinvo", propertyName: "completeinvo", value: statusValue}),
        new SQLField({ fieldName: "f_completecrdb", propertyName: "completecrdb", value: statusValue}),
      ],
      key: new SQLField({ fieldName: hFieldName, propertyName: hFieldName, value: mTbId}),
    }));
  }

  if(sqlInfos.length === 0) return null;
  else return sqlInfos;
}

export function checkCompleteBLForm(mTbName:string, mTbId:number, recogDate:string, userId:string, isSet:boolean): SQLInfo | null {
  if(!mTbName || mTbId <= 0) return null;

  let viewName = "";
  switch(mTbName){
    case "T_OIMMAIN":
      viewName = "V_OIMSTATUS";
      break;
    case "T_OOMMAIN":
      viewName = "V_OOMSTATUS";
      break;
    case "T_AIMMAIN":
      viewName = "V_AIMSTATUS";
      break;
    case "T_AOMMAIN":
      viewName = "V_AOMSTATUS";
      break;
    case "T_GENMAIN":
      viewName = "V_GENSTATUS";  
      break;
    case "T_BTLOAD":
      viewName = "V_BTLSTATUS";
      break;
    default:
      return null;
  }

  if (isSet) {
    return new SQLInfo({
      tableName: mTbName,
      type: SQLType.Update,
      conditionalString: `(SELECT F_BL FROM ${viewName} WHERE F_ID = ${mTbId}) = 'C'`,
      fields: [
        new SQLField({ fieldName: "F_ConfirmedBy", propertyName: "ConfirmedBy", value: userId}),
        new SQLField({ fieldName: "F_ConfirmDate", propertyName: "ConfirmDate", value: recogDate}),
        new SQLField({ fieldName: "F_ConfirmActionDate", propertyName: "ConfirmActionDate", value: 'getDate()'}),
      ],
      key: new SQLField({ fieldName: 'f_id', propertyName: 'Id', value: mTbId}),
    });
  }
  else {
    return new SQLInfo({
      tableName: mTbName,
      type: SQLType.Update,
      fields: [
        new SQLField({ fieldName: "F_ConfirmedBy", propertyName: "ConfirmedBy", value: ''}),
        new SQLField({ fieldName: "F_ConfirmDate", propertyName: "ConfirmDate", value: null }),
        new SQLField({ fieldName: "F_ConfirmActionDate", propertyName: "ConfirmActionDate", value: null }),
      ],
      key: new SQLField({ fieldName: 'f_id', propertyName: 'Id', value: mTbId}),
    });
  }
}

export function checkDutyEntitiesFromDetail(details: any, indexExclude: number = -1) {
  let dutyCustomer = false, dutyAgent = false;
  if (details) {
    for (let i = 0; i < details.length; i++) {
      if (i !== indexExclude && [8, 10, 18, 20, 40].indexOf(details[i].chgType) >= 0) {
        if ([10, 20, 40].indexOf(details[i].chgType) >= 0) {
          dutyCustomer = true;
        } else {
          dutyAgent = true;
        }
      }
    }
  }
  return { dutyCustomer, dutyAgent };
}

export function updateStatusOP(jobName:string, jobIds:string, invoiced:boolean) {
  return new SQLInfo({
    tableName: SQLInfo.UpdateStatusOP,
    type: SQLType.Execute,
    fields: [
      new SQLField({ fieldName: "", propertyName: "jobName", value: jobName}),
      new SQLField({ fieldName: "", propertyName: "jobIds", value: jobIds}),
      new SQLField({ fieldName: "", propertyName: "invoiced", value: invoiced}),
    ],
  });
}

export function acctUpdateStatusOP(jobName:string, jobIds:string, invoiced:boolean) { //whereField
  return new SQLInfo({
    tableName: SQLInfo.UpdateStatusOP,
    type: SQLType.Execute,
    fields: [],
    whereFields:[
      new SQLField({ fieldName: "", propertyName: "jobName", value: jobName}),
      new SQLField({ fieldName: "", propertyName: "jobIds", value: jobIds}),
      new SQLField({ fieldName: "", propertyName: "invoiced", value: invoiced}),
    ]
  });
}